import { call, put, takeEvery } from "redux-saga/effects";
import { earnedMilesRequest, earnedMilesSuccess, earnedMilesFailure } from "../slice/earnedMilesSlice";
import api from "../../../config/api";
import { config } from "../../../config/global";
const API_URL = config?.ROP_EARNED_MILES_API;
const EarnedMilesDetail = async payload => {
  let headerData = {
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken"
    },
    loader: true
  };
  const response = await api.post(API_URL, payload, headerData);
  return response;
};
function* fetchEarnedMiles(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(EarnedMilesDetail, payload);
    yield put(earnedMilesSuccess(response));
  } catch (error) {
    yield put(earnedMilesFailure(error?.response));
  }
}
export function* watchEarnedMiles() {
  yield takeEvery(earnedMilesRequest.type, fetchEarnedMiles);
}